import theme from '../../../lib/theme';
import { TitleProps } from './Title';

const {
  colors,
  corners,
  scale,
  font: { families, heights, spacings, ...font },
} = theme;

export default ({ sponsored_brand }: TitleProps) => ({
  attribution: {
    fontSize: font.s,
    fontWeight: font.normal,
    fontFamily: families.primary,
    lineHeight: heights.l,
    letterSpacing: spacings.m,

    '& em': {
      color: colors.sas.primary,
      fontStyle: 'normal',
      fontWeight: font.bold,
    },
  },
  sponsored: {
    marginRight: scale.xxs,
    backgroundColor: colors.sas.primary,
    color: colors.white,
    fontSize: font.xs,
    borderRadius: corners.s,
    padding: `${scale.xxxxs} ${scale.xxxs}`,
    fontWeight: font.bold,
    display: 'inline-block',
    ':hover': {
      backgroundColor: sponsored_brand ? colors.sas.accent : colors.sas.primary,
    },
  },
  sponsoredLink: {
    color: 'inherit',
    textDecoration: 'none',
  },
});
